import React from 'react';
import {Checkbox, Col, Row, FormGroup} from 'react-bootstrap';
import {Control, Form} from 'react-redux-form';
import RequiredInput from '../../../common/form/elements/required-input';
import Button from '../../../common/button';

const AppVersion = ({onSave}) => (
  <div>
    <Form model="deep.app_version" onSubmit={onSave}>
      <Row>
        <Col lg={3}>
          <RequiredInput label="App version" model=".version"/>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <div className="checkbox" style={{paddingTop: 30}}>
              <Control.checkbox component={Checkbox} model=".force_update">
                Force update
              </Control.checkbox>
            </div>
          </FormGroup>
        </Col>
      </Row>

      <Button submit>
            Save
      </Button>
    </Form>
  </div>
);

export default AppVersion;



// WEBPACK FOOTER //
// ./src/components/admin/app/app-settings/app-version.jsx